import React, {useEffect, useState} from "react";
import {Dropdown} from "primereact/dropdown";
import {classNames} from "primereact/utils";
import classes from "../ParticipantsSetting/ParticipantsSetting.module.css";
import {
    findDataCollectionById,
    getAllDataCollectionDetailsByExcludedStatus,
    getDCBDSFile
} from "../../../../api/dataCollection/dataCollection-service";
import {emptyDataCollection, getPermissionFromOtherDC} from "../../../../api/dataCollection/dataCollection-utils";
import {Checkbox} from "primereact/checkbox";
import {Button} from "primereact/button";
import keycloak from "../../../../keycloak";
import {sortById} from "../../../../api/utils/sortArrays";
import {RadioButton} from 'primereact/radiobutton';
import {StatusCode} from "../../../../entities/StatusContext";
import {ProgressSpinner} from "primereact/progressspinner";


const ExistingDataCollections = (props) => {
    const [selectedPreviousDc, setSelectedPreviousDc] = useState({});
    const [dcId, setDcId] = useState(null);
    const [permissionChecked, setPermissionChecked] = useState(false);
    const [generalChecked, setGeneralChecked] = useState(false);
    const [categoryChecked, setCategoryChecked] = useState(false);
    const [allSettingsChecked, setAllSettingsChecked] = useState(false);
    const [othersDisabled, setOthersDisabled] = useState(false);
    const [reuseDataOption, setReuseDataOption] = useState('None');
    const [dcList, setDcList] = useState([]);
    const [loading, setLoading] = useState(true);


    const itemTemplate = (option) => {
        if (!option) return null;
        if (option.isLoading) {
            return (
                <div style={{display: "flex", alignItems: "center", gap: 8}}>
                    <ProgressSpinner style={{width: 20, height: 20}} strokeWidth={6}/>
                    <span>Loading...</span>
                </div>
            );
        }
        return <div>{option}</div>;
    };

    const dropdownOptions = loading
        ? [{label: "Loading...", value: null, isLoading: true, disabled: true}]
        : sortById(dcList, 'id').map(e => e.name);

    useEffect(() => {
        setLoading(true);
        getAllDataCollectionDetailsByExcludedStatus([StatusCode.DRAFT, StatusCode.DC_CREATION_IN_PROGRESS], true)
            .then(res => {
                setDcList(res)
                setLoading(false);
            })
    }, []);

    const changeDcCopied = (e) => {
        let dc = (dcList.filter(x => x.name === e.value));
        setDcId(dc[0].id)
        setSelectedPreviousDc(e.value);
    }

    function updateIGMSection(res) {
        props.setIsIGM(res.dataCollectionType.code === "IGM")
        props.setBDSFilesValidationResult({
            status: "REPORT_VALID",
            reportPath: null,
            isValidating: false
        });
        const fetchFiles = async () => {
            const files = await getCopiedBDSFiles();
            props.setBDSFiles(files);
        };
        fetchFiles().then(r => {
        });
    }


    const copy = () => {
        findDataCollectionById(dcId).then(res => {
            let dc = emptyDataCollection;
            props.setDataCollection(dc);
            dc.openFrom = ""
            dc.deadline = ""
            dc.categories = [{name: "", topics: []}]
            dc.description = ""
            props.setParticipantsFromOtherDC({});
            props.setNewPermission(getPermissionFromOtherDC([], []));
            props.onChange("openFrom", null)
            props.onChange("deadline", null)
            props.setSelectedVersion(res.model)
            props.onChange("model", res.model)
            props.onChange("categories", res.categories)
            if (allSettingsChecked) {
                props.setParticipantsFromOtherDC(res.participants);
                props.setNewPermission(getPermissionFromOtherDC(res.participants, props.permissionsData));
                props.onChange("openFrom", new Date(res.openFrom))
                props.onChange("deadline", null)
                dc.openFrom = new Date(res.openFrom)
                dc.deadline = null
                dc.description = res.description;
                dc.mailMessage = res.mailMessage;
                dc.tags = res.tags;
                res.categories.forEach(e => {
                    delete e['id']
                });
                dc.categories = res.categories
                dc.model = res.model;
                dc.createdBy = keycloak.idTokenParsed.name
                dc.dataCollectionType = res.dataCollectionType
                updateIGMSection(res);
            } else {
                if (permissionChecked) {
                    props.setParticipantsFromOtherDC(res.participants);
                    props.setNewPermission(getPermissionFromOtherDC(res.participants, props.permissionsData));
                    dc.model = res.model;
                    dc.participants = res.participants;
                }
                if (categoryChecked) {
                    res.categories.forEach(e => {
                        delete e['id']
                    });
                    dc.categories = res.categories;
                    dc.model = res.model;
                }
                if (generalChecked) {
                    props.onChange("openFrom", new Date(res.openFrom))
                    props.onChange("deadline", null)
                    dc.model = res.model;
                    dc.openFrom = new Date(res.openFrom)
                    dc.deadline = null
                    dc.tags = res.tags;
                    updateIGMSection(res);
                }

            }
            dc.copiedFrom = {
                reuseDataOption: reuseDataOption,
                copiedFromDc: {
                    id: res.id,
                    name: res.name,
                    description: res.description,
                    startFrom: res.openFrom,
                    deadline: res.deadline,
                    dataStatus: res.dataStatus,
                    dataCollectionStatus: res.status,
                    modelVersionName: res.model.name,

                },
                copyGeneralSettings: allSettingsChecked || generalChecked,
                copyParticipants: allSettingsChecked || permissionChecked,
                copyCategories: allSettingsChecked || categoryChecked,


            };
            props.onChange("copiedFrom", res)
            props.setDataCollection(dc)

        })
        props.setDisplay(false)

    }

    const getCopiedBDSFiles = async () => {
        const [equipmentFile, topologyFile] = await Promise.all([
            getDCBDSFile(dcId, "eq-"),
            getDCBDSFile(dcId, "tp-")
        ]);

        return {
            equipment: equipmentFile,
            topology: topologyFile
        };

    }
    return (
        <div>
            <Dropdown options={dropdownOptions} value={selectedPreviousDc}
                      className={classNames(classes.selectStyle, classes.dcPermission)}
                      placeholder={loading ? "Loading..." : "Select data collection"}
                      itemTemplate={itemTemplate}
                      optionDisabled="disabled"
                      onChange={e => changeDcCopied(e)} filter
            />
            <br/>
            <br/>
            {/*all settings*/}
            <div style={{display: "flex"}}>
                <div style={{width: '50%'}}>
                    <h4> Copy data collection settings </h4>
                    <Checkbox className="custom-checkbox" inputId="allSettings" onChange={e => {
                        setAllSettingsChecked(e.checked);
                        setOthersDisabled(e.checked);
                        setPermissionChecked(false);
                        setGeneralChecked(false);
                        setCategoryChecked(false);
                    }}
                              checked={allSettingsChecked}
                    />
                    <label htmlFor="allSettings" className={classes.checkboxLabel}>All settings</label>


                    <br/>
                    {/*General settings*/}

                    <Checkbox style={{marginTop: "20px"}} inputId="general" onChange={e => {
                        setGeneralChecked(e.checked)
                    }}
                              checked={generalChecked}
                              disabled={othersDisabled}/>
                    <label htmlFor="general" className={classes.checkboxLabel}>General settings</label>
                    <br/>

                    {/*Permissions*/}
                    <Checkbox style={{marginTop: "20px"}} inputId="permission" onChange={e => {
                        setPermissionChecked(e.checked);
                    }}
                              checked={permissionChecked}
                              disabled={othersDisabled}/>
                    <label htmlFor="permission" className={classes.checkboxLabel}>Participants and permissions</label>
                    <br/>

                    {/*Categories*/}
                    <Checkbox style={{marginTop: "20px"}} inputId="categories" onChange={e => {
                        setCategoryChecked(e.checked)
                    }}
                              checked={categoryChecked}
                              disabled={othersDisabled}/>
                    <label htmlFor="categories" className={classes.checkboxLabel}>Categories</label>
                    <br/>

                </div>
                <div style={{width: '50%'}}>

                    <h4> Reuse data </h4>
                    <div className="flex align-items-center" style={{marginBottom: "20px"}}>
                        <RadioButton inputId="option1" value="None" onChange={(e) => setReuseDataOption(e.value)}
                                     checked={reuseDataOption === 'None'}/>
                        <label htmlFor="option1" className="ml-2">None</label>
                    </div>
                    <div className="flex align-items-center" style={{marginBottom: "20px"}}>
                        <RadioButton inputId="option2" value="Reuse_data_only_in_template"
                                     onChange={(e) => setReuseDataOption(e.value)}
                                     checked={reuseDataOption === 'Reuse_data_only_in_template'}/>
                        <label htmlFor="option2" className="ml-2">Reuse data in template only</label>
                    </div>
                    <div className="flex align-items-center" style={{marginBottom: "20px"}}>
                        <RadioButton inputId="option3" value="Reuse_data_and_validation_status"
                                     onChange={(e) => setReuseDataOption(e.value)}
                                     checked={reuseDataOption === 'Reuse_data_and_validation_status'}/>
                        <label htmlFor="option3" className="ml-2">Reuse data and validation status</label>
                    </div>
                    <div className="flex align-items-center" style={{marginBottom: "20px"}}>
                        <RadioButton inputId="option4" value="Reuse_data_and_revalidate_all_data"
                                     onChange={(e) => setReuseDataOption(e.value)}
                                     checked={reuseDataOption === 'Reuse_data_and_revalidate_all_data'}/>
                        <label htmlFor="option4" className="ml-2">Reuse data and revalidate all data</label>
                    </div>

                </div>
            </div>
            {/*Button copy*/}
            <Button className={classes.btnStyle}
                    disabled={!(allSettingsChecked || permissionChecked || categoryChecked || generalChecked) || selectedPreviousDc.length === undefined}
                    label="Copy" icon="pi pi-copy"
                    onClick={copy}
            />
        </div>
    )
}
export default ExistingDataCollections;
